export default __webpack_public_path__ + "static/media/fossa-long.fcd06290.svg";